/**
 * @module KUP
 */
(function($) {

    'use strict';

    if(typeof KUP === 'undefined') {
        return null;
    }

    /**
     * ScrollSmooth module
     *
     * @class jqCustom.ScrollSmooth
     */
    var ScrollSmooth = (function() {

        /**
         * event type
         *
         * @private
         * @property evtType
         * @type {String}
         */
        var evtType = window.touch ? 'touchstart' : 'click',

        /**
         * Reference on the anchor links
         *
         * @private
         * @property anchorLinks
         * @type {Object}
         */
            anchorLinks;

        /**
         * Initialization of the module
         *
         * @method init
         *
         */
        function init() {
            // handle anchor in URL
            if(window.location.hash) {
                setTimeout(function(){
                    scrollToElement(window.location.hash,true);
                },500);
            }

            // handle anchor-links
            anchorLinks = $('a[href^="#"]').not('.no-scroll-smooth');
            if(anchorLinks.length) {
                initListener();
            }
        }

        /**
         * Register Listener
         *
         * @private
         * @method initListener
         */
        function initListener() {
            $(anchorLinks).on(evtType, function(event) {
                event.preventDefault();
                var hash = $(this).attr('href');
                scrollToElement(hash);
            });
        }

        function scrollToElement(hash,onLoadIndicator) {
            var htmlBody = $('html, body'),
                tabletPortrait = window.matchMedia("(max-width: 991px)").matches,
                delta = 0,
                hashOffset = 0;

            if($(hash).length == 1){
                hashOffset = $(hash).offset().top;
            }

            if($(hash).data('aos')) {
                if($(hash).data('aos').indexOf('-up') != -1 && !$(hash).hasClass('aos-animate')) {
                    delta = -100;
                } else if($(hash).data('aos').indexOf('-down') != -1 && !$(hash).hasClass('aos-animate')) {
                    delta = 100;
                }
            }

            hashOffset = hashOffset + delta;
            if(hashOffset != 0){
                htmlBody.animate({
                    scrollTop: parseInt(hashOffset - $('header').outerHeight())
                }, 800);

                // set new hash to location
                if(hash !== 'undefined') {
                    window.location.hash = hash;
                }
            }
        }

        /**
         * @return Public-API
         */
        return {
            init: init
        };

    }());

    /**
     *
     * @for jqCustom
     * @property ScrollSmooth
     * @type {Function}
     */
    KUP.ScrollSmooth = ScrollSmooth;

    return ScrollSmooth;

}(jQuery));
